import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { deleteItems, updateStateData } from "../../../Store/actions";
import { Box } from "@mui/material";
import { SpaceBetweenStack } from "../../../components/commonComponents/StyledComponents/styled";
import ActionButton from "../../../components/commonComponents/Buttons/ActionButton";
import { loadClips } from "../../../api_calls/clipRequests";
import { checkUserRole } from "../../../api_calls/userManagement";
import { useNavigate } from "react-router-dom";
import { createCookie, deleteCookie } from "../../../api_calls/requestConfig";
import FilterPanel from "../../../components/commonComponents/Filters/FilterPanel";

const ClipListFilters = (props) => {
  const Clips = useSelector((state) => state.userSelections);
  const verifyUserRoleName = checkUserRole();
  const navigate = useNavigate();

  const dispatchAction = useDispatch();

  const saveClipFilters = (filters) => {

    const filterValues = {
      campaign_name: filters.campaign_name || [],
      clip_name: filters.clip_name || [],
      clip_company_name: filters.owner || [],
      status_filter: filters.status || [],
      clip_store_filter: filters.store_name || [],
      clip_visual_type: filters.clip_visual_type || null,
    };
    const noFiltersSelected =
      (!filterValues.campaign_name || filterValues.campaign_name.length === 0) &&
      (!filterValues.clip_name || filterValues.clip_name.length === 0) &&
      (!filterValues.clip_company_name || filterValues.clip_company_name.length === 0) &&
      (!filterValues.status_filter || filterValues.status_filter.length === 0) &&
      (!filterValues.clip_store_filter || filterValues.clip_store_filter.length === 0) && 
      (!filterValues.clip_visual_type)
    if (noFiltersSelected) {
      // If nothing is selected, clear existing filters and return
      clearfilters();
      return;
    }
    // Persist to Redux for future retrieval (e.g. report generation)
    dispatchAction(
      updateStateData({
        clip_list_filters: filterValues,
        clips_list_filter_applied: true,
      })
    );
    // Persist to cookies for session persistence
    createCookie("clip_list_filters", JSON.stringify(filterValues));
    // Reload clips using the current page size (reset to page 1)
    loadClips(0, Clips.clips_pagination.pageSize);
  };

  const clearfilters = () => {
    // Remove filter cookie
    deleteCookie("clip_list_filters", true);
    // Clear state in Redux (removes filters and resets flagged state)
    dispatchAction(deleteItems(["clip_list_filters", "filtered_clips_list", "clips_list_filter_applied"]));
    // Reload unfiltered list
    loadClips(0, Clips.clips_pagination.pageSize);
  };

  const clipFiltersConfig = React.useMemo(
    () => [
      {
        key: "clip_name",
        label: "Visual Name",
        type: "multi",
        options: () => Clips?.clip_names_info?.clip_names_list,
      },
      {
        key: "campaign_name",
        label: "Campaign Name",
        type: "multi",
        options: () =>
          typeof Clips?.campaign_names_info !== "undefined"
            ? Clips?.campaign_names_info?.campaign_name_obj
            : [],
      },
      {
        key: "status",
        label: "Progress",
        disableSearch: true,
        type: "multi",
        selectionParam: "label",
        disableSearch: true,
        options: () => [
          { value: 1, label: "Active" },
          { value: 2, label: "Scheduled" },
          { value: 3, label: "Completed" },
          { value: 4, label: "Stopped" },
        ],
      },
      {
        key: "owner",
        label: "Owner",
        type: "multi",
        options: () => Clips?.companies_info,
      },
      {
        key: "store_name",
        label: "Store Name",
        type: "multi",
        options: () => Clips?.store_names_info?.store_names_list,
      },
      {
        key: "clip_visual_type",
        label: "Type",
        disableSearch: true,
        type: "single",
        selectionParam: "value",
        options: () => [
          { value: 'commercial', label: 'Commercial' },
          { value: 'unlimited', label: 'Unlimited' },
        ],
      },
      // {
      //   key: "clip_visual_type",
      //   label: "Type",
      //   type: "single",
      //   selectionParam: "value",
      //   options: () => [
      //     { value: 'commercial', label: 'Commercial' },
      //     { value: 'unlimited', label: 'Unlimited' },
      //   ],
      // },
    ],
    [Clips]
  );


  return (
    <>
      {/* ----------- filter row 1 -------- */}
      <Box>
        <SpaceBetweenStack
          direction={"row"}
          spacing={2}
          width={"100%"}
          justifyContent={"space-between"}
          display={"flex"}
        >
          <FilterPanel
            filtersConfig={clipFiltersConfig}
            applyFilterFunc={saveClipFilters}
            clearFilterFunc={clearfilters}
            initiallyAppliedVals={Clips.clip_list_filters}
          />

          {/* ------ overview should be hidden for brand user ----- */}
          {verifyUserRoleName.user_role !== "Brand" && (
            <ActionButton
              onClick={(e) => {
                // e.preventDefault();
                navigate("/check-campaigns/visuals-overview");
              }}
              label={"Overview"}
            />
          )}
        </SpaceBetweenStack>
      </Box>
    </>
  );
}

export default ClipListFilters;
